import React, { useContext } from 'react';

import { LicenseType } from '@/core/api/collections/users';
import { AuthContext } from '@/core/auth/AuthContext';
import { ERROR_NO_SELF_CHANGES, ERROR_NOT_AN_ADMIN } from '@/core/users/UserPermissions/constants';
import { LicenseTypeSelect } from '@/core/users/UserPermissions/UserDetails/LicenseTypeSelect';
import { UserEditContext } from '@/core/users/UserPermissions/UserEditContext';
import { validateLicenseType } from '@/core/users/UserPermissions/userEditValidators';

export function LicenseTypeSelectContainer () {
  const { currentUser, licensesRemaining } = useContext(AuthContext);
  const { user, updateUser, errors, setErrors } = useContext(UserEditContext);

  let disabledMessage;
  if (currentUser!.id === user!.id) {
    disabledMessage = ERROR_NO_SELF_CHANGES;
  } else if (!currentUser!.coreOwner) {
    disabledMessage = ERROR_NOT_AN_ADMIN;
  }

  const handleChange = (licenseType: LicenseType) => {
    if (licenseType) {
      if (licensesRemaining) {
        const error = validateLicenseType(licenseType, licensesRemaining);
        if (error) {
          setErrors({ ...errors, licenseType: error });
        } else {
          delete errors.licenseType;
          setErrors({ ...errors });
        }
      }
      if (user!.permissions.core) {
        user!.permissions.core.licenseType = licenseType;
      }
      updateUser(user!);
    }
  };

  return (
    <LicenseTypeSelect
      disabledMessage={disabledMessage}
      licenseType={user?.permissions.core?.state === 'deleted' ? undefined : user?.permissions.core?.licenseType}
      uvkAdmin={user?.permissions.uvk?.admin}
      onChange={handleChange}
      errorMessage={errors?.licenseType}
    />
  );
}
